<hb-modal-dialog id="confirm-dialog" [heading]="title" [showFooter]="false">
  <div content>
    <div *ngIf="showPrimaryAlert" class="alert alert-primary">
      {{ alertMessage }}
    </div>
    <p>{{ messageTop }}</p>
    <p *ngIf="messageBottom">{{ messageBottom }}</p>
    <div *ngIf="includeInstallationDatePicker" class="form-group mt-3">
      <label class="font-weight-bold" for="confirmation-dialog-installation-date">{{ 'InstallationDate' | i18next }}</label>
      <hb-datepicker-control
        name="confirmation-dialog-installation-date"
        controlId="confirmation-dialog-installation-date"
        [(ngModel)]="installationDate"
        [isDisabled]="false"
        placeholderText="{{ 'InstallationDate' | i18next }}"
      ></hb-datepicker-control>
    </div>
  </div>
  <div footerContent>
    <button id="confirm-dialog-false" type="button" *ngIf="showCancel" class="btn btn-default pull-right" (click)="submit(false)">
      {{ negativeActionLabel }}
    </button>
    <button id="confirm-dialog-true" type="button" class="btn btn-primary" (click)="submit(true)">{{ affirmativeActionLabel }}</button>
  </div>
</hb-modal-dialog>
